import { useTranslation } from 'react-i18next'

import { DetailsField } from './DetailsField'

interface DeliveryAnnotationFieldProps {
  deliveriesWithNotes?: number
  totalDeliveries?: number
}

export const DeliveryAnnotationField: React.FC<DeliveryAnnotationFieldProps> = ({
  deliveriesWithNotes = 0,
  totalDeliveries = 0
}) => {
  const { t } = useTranslation()

  return (
    <DetailsField
      dataTestId="delivery-annotations"
      label={t('order.orderDetails.deliveryAnnotations')}
      value={`${deliveriesWithNotes}/${totalDeliveries}`}
    />
  )
}
